import DeckHome from '@/components/deck-home/DeckHome';
import React from 'react';

export default function DeckViewPage() {
  return <DeckHome />;
}
